import Axios from "axios";
import { authHeader } from "../helpers";
import config from "../config";

export const GET_KEYWORDS_REQUEST = 'GET_KEYWORDS_REQUEST';
export const GET_KEYWORDS_REQUEST_SUCCESS = 'GET_KEYWORDS_REQUEST_SUCCESS';
export const GET_KEYWORDS_REQUEST_FAILURE = 'GET_KEYWORDS_REQUEST_FAILURE';

export const CREATE_KEYWORDS_REQUEST = 'CREATE_KEYWORDS_REQUEST';
export const CREATE_KEYWORDS_REQUEST_SUCCESS = 'CREATE_KEYWORDS_REQUEST_SUCCESS';
export const CREATE_KEYWORDS_REQUEST_FAILURE = 'CREATE_KEYWORDS_REQUEST_FAILURE';

export const DELETE_KEYWORDS_REQUEST = 'DELETE_KEYWORDS_REQUEST';
export const DELETE_KEYWORDS_REQUEST_SUCCESS = 'DELETE_KEYWORDS_REQUEST_SUCCESS';
export const DELETE_KEYWORDS_REQUEST_FAILURE = 'DELETE_KEYWORDS_REQUEST_FAILURE';

export const FETCH_CHABOT_REPORT_DATA = 'FETCH_CHABOT_REPORT_DATA';
export const FETCH_CHABOT_REPORT_DATA_SUCCESS = 'FETCH_CHABOT_REPORT_DATA_SUCCESS';
export const FETCH_CHABOT_REPORT_DATA_FAILURE = 'FETCH_CHABOT_REPORT_DATA_FAILURE';

export const FETCH_KM_SOURCE_DATA = 'FETCH_KM_SOURCE_DATA';
export const FETCH_KM_SOURCE_DATA_SUCCESS = 'FETCH_KM_SOURCE_DATA_SUCCESS';
export const FETCH_KM_SOURCE_DATA_FAILURE = 'FETCH_KM_SOURCE_DATA_FAILURE';

export const UPDATE_KM_SOURCE_DATA = 'UPDATE_KM_SOURCE_DATA';
export const UPDATE_KM_SOURCE_DATA_SUCCESS = 'UPDATE_KM_SOURCE_DATA_SUCCESS';
export const UPDATE_KM_SOURCE_DATA_FAILURE = 'UPDATE_KM_SOURCE_DATA_FAILURE';


//Exceptional
export const getExceptionalKeywords = () => async (dispatch) => {
    try {
        dispatch({ type: GET_KEYWORDS_REQUEST });
        let page = 1;
        let hasMoreKeywords = true;
        let allKeywords = [];
        while (hasMoreKeywords) {
            const limit = 50;
            const response = await Axios.get(`${process.env.REACT_APP_API_URL}/vertex-keyword?page=${page}&limit=${limit}`, { headers: authHeader() });
            const data = response?.data?.data;
            allKeywords = [...allKeywords, ...data];

            if (data?.length < limit) {
                hasMoreKeywords = false;
            } else {
                page++;
            }
        }

        dispatch({ type: GET_KEYWORDS_REQUEST_SUCCESS, payload: allKeywords });
    } catch (err) {
        dispatch({ type: GET_KEYWORDS_REQUEST_FAILURE, error: err });
    }
}

export const createExceptionalKeyword = (keyword) => async (dispatch) => {
    try {
        dispatch({ type: CREATE_KEYWORDS_REQUEST });
        const response = await Axios.post(`${process.env.REACT_APP_API_URL}/vertex-keyword`, { keyword }, { headers: authHeader() });
        dispatch({ type: CREATE_KEYWORDS_REQUEST_SUCCESS, payload: response?.data });
    } catch (err) {
        dispatch({ type: CREATE_KEYWORDS_REQUEST_FAILURE, error: err });
    }
}

export const deleteExceptionalKeyword = (id, keyword) => async (dispatch) => {
    try {
        dispatch({ type: DELETE_KEYWORDS_REQUEST });
        const response = await Axios.delete(`${process.env.REACT_APP_API_URL}/vertex-keyword/${id}`, { headers: authHeader() });
        dispatch({ type: DELETE_KEYWORDS_REQUEST_SUCCESS, payload: { id, keyword } });
    } catch (err) {
        dispatch({ type: DELETE_KEYWORDS_REQUEST_FAILURE, error: err });
    }
}

//Report
export const fetchChatbotReportData = (pageNo, pageLimit = 50, formData) => async (dispatch) => {
    try {
        dispatch({ type: FETCH_CHABOT_REPORT_DATA });
        const chatbotReport = await Axios.get(
            `${process.env.REACT_APP_API_URL}/vertex/session/search?page=${pageNo}&limit=${pageLimit}`,
            { params: formData, headers: authHeader() });
        dispatch({
            type: FETCH_CHABOT_REPORT_DATA_SUCCESS,
            payload: chatbotReport.data
        });
    } catch (err) {
        dispatch({ type: FETCH_CHABOT_REPORT_DATA_FAILURE, error: err })
    }
}

//Get KM source
export const getKmSourceData = (pageNo, pageLimit = 50, formData) => async (dispatch) => {
    try {
        dispatch({ type: FETCH_KM_SOURCE_DATA });
        const response = await Axios.get(`${config.API_URL}/vertex-knowledge-management?page=${pageNo}&limit=${pageLimit}`, {
            params: formData,
            headers: authHeader(),
        });
        dispatch({
            type: FETCH_KM_SOURCE_DATA_SUCCESS,
            payload: response?.data
        });
    } catch (err) {
        dispatch({ type: FETCH_KM_SOURCE_DATA_FAILURE, error: err })
    }
};

//Create signed_uri
export const createKmSourceData = async (createBody) => {
    const response = await Axios.post(`${config.API_URL}/vertex-knowledge-management`, createBody,
        {
            headers: authHeader(),
        });
    return response?.data;
};

//Update KmSource metadata
export const updateKmSourceData = async (patchBody) => {
    const response = await Axios.patch(`${config.API_URL}/vertex-knowledge-management`, patchBody,
        {
            headers: authHeader(),
        });
    return response?.data;
};

//Download KmSource
export const getDownloadFile = async (fileName) => {
    const response = await Axios.get(`${config.API_URL}/vertex-knowledge-management/download/${fileName}`,
        {
            headers: authHeader(),
        });
    return response?.data;
}

//Delete KmSource
export const deleteKmSource = async (fileName, docId) => {
    const response = await Axios.delete(`${config.API_URL}/vertex-knowledge-management?fileName=${fileName}&docId=${docId}`,
        {
            headers: authHeader(),
        });
    return response;
}

//Refresh status 
export const refreshKmSource = async (dispatch, fileName) => {
    try {
        dispatch({ type: UPDATE_KM_SOURCE_DATA });
        const response = await Axios.get(`${config.API_URL}/vertex-knowledge-management/refresh?fileName=${fileName}`,
            {
                headers: authHeader(),
            });
        dispatch({
            type: UPDATE_KM_SOURCE_DATA_SUCCESS,
            payload: response?.data
        });
        return response;
    } catch (err) {
        dispatch({ type: UPDATE_KM_SOURCE_DATA_FAILURE, error: err })
    }
}

//Edit create signed_uri KmSource
export const editKmSourceData = async (putBody, fileChange = "false") => {
    const response = await Axios.put(`${config.API_URL}/vertex-knowledge-management?fileChange=${fileChange}`, putBody,
        {
            headers: authHeader(),
        });
    return response?.data;
};